import * as React from 'react'
import { FullScreenDialog } from '@user/components/FullScreenDialog'
import { useHandlers } from './hooks'
import { ActivitySummaryDialogContent } from './ActivitySummaryDialogContent'

export function ActivitySummaryDialog() {
  const { open, onClose } = useHandlers()

  return (
    <FullScreenDialog
      open={open}
      onClose={onClose}
      closeButtonText="Close Activity Summary"
    >
      <ActivitySummaryDialogContent />
    </FullScreenDialog>
  )
}
